import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { titleFromFilename } from './useCardVideoUpload';

export default function VideoMetadataPromptDialog({
  open,
  fileName,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  fileName?: string;
  onCancel: () => void;
  onConfirm: (title: string, description: string) => void;
}) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (!open) return;
    setTitle(fileName ? titleFromFilename(fileName) : '');
    setDescription('');
  }, [open, fileName]);

  const canUpload = title.trim().length > 0 && description.trim().length > 0;

  const stopBubble = (event: React.SyntheticEvent) => event.stopPropagation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      aria-labelledby="video-metadata-title"
      onClick={stopBubble}
      onMouseDown={stopBubble}
      onKeyDown={stopBubble}
    >
      <DialogTitle id="video-metadata-title">Add to video library</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
        <TextField
          autoFocus
          required
          fullWidth
          label="Title"
          helperText="Shown to viewers when the video plays"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
        />
        <TextField
          required
          fullWidth
          multiline
          minRows={2}
          label="Description"
          helperText="Shown to viewers when the video plays"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!canUpload}
          onClick={() => onConfirm(title.trim(), description.trim())}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
